import React from "react";
import PropTypes from "prop-types";
import { translate } from "application/functions";
import mobileError from "assets/img/mobile-error.jpg";
import webError from "assets/img/web-error.jpg";
export default function ErrorPage(props) {
  const { locale, size } = props;

  const getImage = () => {
    if (size === "xs_vertical" || size === "") {
      return mobileError;
    }
    return webError;
  };

  const getVeil = () => {
    if (size === "ultrawide") {
      return "linear-gradient(0deg, rgba(0, 0, 0, 0.35), rgba(0, 0, 0, 0.35)), ";
    }
    return "";
  };

  return (
    <div
      className="error-page__container"
      style={{ backgroundImage: `${getVeil()}url(${getImage()}` }}
    >
      <div className="error-page__message">
        <div className="error-page__title">
          {translate(`error.title.generic`, locale)}
        </div>
      </div>
    </div>
  );
}

ErrorPage.propTypes = {
  locale: PropTypes.string,
  size: PropTypes.string,
  showExpired: PropTypes.bool,
  showAnswered: PropTypes.bool,
};
